<template>
    <div class="kleptos-taskbar-system-tray">

        <!-- ICONS -->
        <!-- <button class="kleptos-system-tray-btn"><i class="fa fa-battery-3"></i></button> -->
        <!-- <button class="kleptos-system-tray-btn user-level-btn">06</button> -->
        <button class="kleptos-system-tray-btn"><i class="fa fa-volume-off"></i></button>

        <!-- SYSTEM CLOCK -->
        <button class="kleptos-system-tray-btn">
            <time class="kleptos-system-clock" :datetime="Date.now()">{{ currentTime }}</time>
        </button>
    </div>
</template>

<script>
    // import DockSlot from './Slot';
    import moment from 'moment';

    export default {
        components: {
            // KleptosDockSlot: DockSlot,
            // KleptosDockUserLevel: UserLevel,
        },
        data(){
            return {
                // dateTime: Date.now(),
                currentTime: null
            }
        },
        computed: {
            // dateString() {
                // var date = this.dateTime;
                // return moment(date).format('hh:mm:ss A');
                // return moment(date).format('dddd MMMM DD, hh:mma');
            // },
            // dateTimestamp() {
            //     return moment(this.dateTime);
            // }
        },
        created() {
            this.currentTime = moment().format('hh:mm A');
            setInterval(() => this.updateCurrentTime(), 1 * 1000);
        },
        methods: {
            updateCurrentTime() {
                this.currentTime = moment().format('hh:mm A');
            }
        },
    }
</script>

<style lang="scss" scoped>
    .kleptos-taskbar-system-tray {
        display: flex;
        align-items: center;
        padding: rem-calc(0 10);
        border-left: 1px solid rgba(#a8a595, 0.4);
        background: #e1e1d4;
    }

    .kleptos-system-tray-btn {
        position: relative; // [LOCKED]
        top: 1px; // [LOCKED] - perfect
        border: 0; // [RESET]
        background: none; // [RESET]
        padding: rem-calc(0 5);
    }

    // .user-level-btn {
    //     height: 100%;
    //     text-align: center;
    //     background: url(~@/assets/img/hexagon.svg) no-repeat;
    //     background-position: 49% center;
    //     background-size: 17px;
    //     font-family: 'Pixeleris';
    //     font-size: 8px;
    //     text-align: center;
    //     // font-weight: 600;
    //     color: #e1e1d4;
    // }

    .kleptos-system-clock {
        display: block;
        width: rem-calc(70);
        // border-left: 1px solid red;
        text-align: right; // [LOCKED]
        white-space: nowrap; // [LOCKED]
    }
</style>